import $ from 'jquery';
import {
  acceptCookieFunc,
  anchorLinks,
  cvFormPopupHandler,
  debounce,
  enteredLetterCounting,
  filteringVacancies,
  formSubmitHandler,
  initMobileNavDropdowns,
  scrollToTop,
  startLottiesAnimation,
  swiperInitHandler,
  switchingCVVariants,
  updateDropdownPositions,
  updateDropdownToggle,
  handleAccordion,
} from './functions';
import { initSplineAnimation } from './spline-animation';
import { initLandingAnimations } from './landing-animations';

(($) => {
  document.addEventListener('DOMContentLoaded', function () {
    // hamburger menu icon
    $('.navbar-toggler').click(function () {
      $(this).find('.navbar-toggler-icon').toggleClass('open');
    });

    document.querySelectorAll('p').forEach((paragraph) => {
      if (!paragraph.textContent.replace(/\u00A0/g, '').trim()) {
        paragraph.remove();
      }
    });

    formSubmitHandler('contact', '#contact_form_container');
    formSubmitHandler('apply_cv', '#contact_form_container');
    formSubmitHandler('contact_us', '#contact_form_container');
    formSubmitHandler('answer_form', '#contact_form_container');

    updateDropdownPositions();
    window.addEventListener('resize', debounce(updateDropdownPositions, 110));

    updateDropdownToggle();
    window.addEventListener('resize', updateDropdownToggle);

    initMobileNavDropdowns();

    // Init Anchor links logic
    anchorLinks(180);

    filteringVacancies();

    cvFormPopupHandler();

    switchingCVVariants();

    enteredLetterCounting();

    swiperInitHandler();

    scrollToTop();

    acceptCookieFunc();

    (window.__preloaderHidden || Promise.resolve()).then(function () {
      initLandingAnimations();
      document.documentElement.classList.remove('is-preloading');
      startLottiesAnimation();
      initSplineAnimation();
    });

    const lazyVideos = document.querySelectorAll('.js-lazy-video');
    if (lazyVideos.length) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const video = entry.target;
            video.querySelectorAll('source[data-src]').forEach((source) => {
              source.src = source.dataset.src;
              source.removeAttribute('data-src');
            });
            video.load();
            video.addEventListener(
              'canplay',
              () => {
                video.classList.add('is-playing');
              },
              { once: true },
            );
            videoObserver.unobserve(video);
          });
        },
        { rootMargin: '200px' },
      );

      lazyVideos.forEach((video) => videoObserver.observe(video));
    }

    handleAccordion();

    const formSelects = document.querySelectorAll('.js-form-select');
    formSelects &&
      formSelects.forEach((formSelect) => {
        const choices = new Choices(formSelect, {
          searchEnabled: false,
          searchChoices: false,
          itemSelectText: '',
        });
      });
  });
})($);
